import PropTypes from 'prop-types';
import React from 'react';
import { TabPane } from 'reactstrap';
import FollowupCard from './followupCard';
const FollowupsTab = _ref => {
  let followupsArray = _ref.followupsArray,
    _ref$content = _ref.content,
    content = _ref$content === void 0 ? null : _ref$content,
    _ref$path = _ref.path,
    path = _ref$path === void 0 ? '' : _ref$path,
    _ref$formActions = _ref.formActions,
    formActions = _ref$formActions === void 0 ? null : _ref$formActions,
    _ref$reduxEntity = _ref.reduxEntity,
    reduxEntity = _ref$reduxEntity === void 0 ? '' : _ref$reduxEntity,
    _ref$pendingOperation = _ref.pendingOperation,
    pendingOperation = _ref$pendingOperation === void 0 ? false : _ref$pendingOperation,
    _ref$notificationActi = _ref.notificationActions,
    notificationActions = _ref$notificationActi === void 0 ? null : _ref$notificationActi;
  return /*#__PURE__*/React.createElement(TabPane, {
    tabId: "followups"
  }, /*#__PURE__*/React.createElement("div", {
    className: "px-3"
  }, followupsArray.map(followup => /*#__PURE__*/React.createElement(FollowupCard, {
    key: followup.id,
    followupId: followup.id,
    followup: followup,
    content: content,
    path: path,
    formActions: formActions,
    reduxEntity: reduxEntity,
    pendingOperation: pendingOperation,
    notificationActions: notificationActions
  }))));
};
FollowupsTab.propTypes = {
  followupsArray: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string
  })).isRequired,
  content: PropTypes.shape({
    title: PropTypes.string,
    formType: PropTypes.shape({
      name: PropTypes.string
    })
  }),
  path: PropTypes.string,
  formActions: PropTypes.shape({
    change: PropTypes.func.isRequired
  }),
  reduxEntity: PropTypes.string,
  pendingOperation: PropTypes.bool,
  notificationActions: PropTypes.shape({
    info: PropTypes.func
  })
};
export default FollowupsTab;